let commonSetup = () => {
  window.removeEventListener("load", commonSetup, false); // remove listener, no longer needed

  const supportUnreadElement = document.getElementById("support-unread-count");
  if (window.hasOwnProperty("Intercom") && supportUnreadElement != null) {
    Intercom("onUnreadCountChange", (unreadCount: number) => {
      if (unreadCount > 0) {
        supportUnreadElement.textContent = " (" + unreadCount + ")";
      } else {
        supportUnreadElement.textContent = "";
      }
    });
  }
};

window.addEventListener("load", commonSetup, false);
